<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ $tc("inventoriesRefills.title") }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button
      class="button"
      @click="$emit('get-inventories-refills')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="sync-alt"></b-icon>
    </button>

    &nbsp;
    <button
      class="button"
      @click="$emit('download-inventories-refills-report')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="save"></b-icon>
    </button>

    <br v-show="c2" />

    <span v-show="!c2">&nbsp;&nbsp;&nbsp;</span>
    <span
      :style="
        c1
          ? 'position: relative; top: -0.1rem;'
          : 'position: relative; top: -1.1rem;'
      "
    >
      <b-datepicker
        style="width: 210px; display: inline-block;"
        :placeholder="$t('common.selectPeriod')"
        v-model="dates"
        range
        @input="$emit('update-dates', dates)"
        :mobile-native="false"
      ></b-datepicker>
    </span>

    <b-field style="margin-top: 10px">
      <b-select
        :placeholder="$t('common.store')"
        class="inline"
        v-model="store"
        @input="$emit('update-store', store)"
      >
        <option value="">{{ $t("common.allStores") }}</option>
        <option
          v-for="s in stores"
          :key="s._id"
          :value="`${s._id}|${s.storeInfo.name}`"
        >
          {{ s.storeInfo.name }}
        </option>
      </b-select>
    </b-field>

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["storeId", "storeName"],

  mixins: [responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      dates: [],
      store: undefined
    };
  },

  computed: {
    ...mapGetters(["stores"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    }
  },

  mounted() {
    this.store = `${this.storeId}|${this.storeName}`;
    this.dates = [new Date(), new Date()];
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
